
.EventItem {
    --EventItem-colour: var(--soniq-t--global--background--color--surface--event);
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    background: var(--EventItem-colour, var(--soniq-t--global--background--color--surface--event));
    border: solid 1px var(--soniq-t--global--border--color--event--default);
    border-left: solid 4px var(--soniq-t--global--border--color--event--opaque);
    cursor: pointer;
    color: var(--soniq-t--global--text--color--primary--default);

    &.isDisabled {
        cursor: not-allowed;
    }

    &.isBackgroundEvent {

    }

    &.isSelected {
        border-left-color: var(--soniq-t--global--palette--deep-pink);
        background: var(--soniq-t--global--palette--hot-pink);
        color: var(--soniq-t--global--text--color--blockbg--contrast);

        .EventItem__content {
            text-shadow: none;
        }
    }
}

.EventItem__button {
    width: 100%;
    height: 100%;
    display: block;
}

.EventItem__content {
    padding: 4px 2px 2px 3px;
    text-shadow: 1px 1px var(--soniq-t--global--text--shadow--contrast);
}

.EventItem__contentTitle {
    display: block;
    font-size: .7rem;
    line-height: 1;
    text-align: left;
}
